// add function to format display of phone numbers

export function undefOrEmpty(value: any): string {
  return typeof value === 'undefined' || value === null ? '' : value;
}

export function toLabelArray(matList: { [key: string]: { [key: string]: string } }[], type: string): string {
  let res: string = '';

  if (matList.length > 0) {
    matList.forEach((element: { [key: string]: { [key: string]: string } }) => {
      const matTableName = 'material' + type.charAt(0).toUpperCase() + type.slice(1);

      res = res + element[matTableName]['label'] + ', ';
    });

    res = res.slice(0, -2);
  }
  return res;
}

export function failSafeResponseStructure(
  response: any,
  dataAttribute: boolean = false,
  shouldBeArray: boolean = false
): boolean {
  if (dataAttribute) {
    if (!Object.prototype.hasOwnProperty.call(response, 'data')) {
      console.error('Response does not have an attribute "data"');

      return false;
    }

    if (shouldBeArray && !Array.isArray(response.data)) {
      console.error('Response.data is not an array');

      return false;
    }
  } else if (!dataAttribute) {
    if (shouldBeArray && !Array.isArray(response)) {
      console.error('Response is not an array');

      return false;
    }
  }

  return true;
}

export function toTitleCaseFromCamelCase(value: string): string {
  const result: string = value.replace(/([A-Z])/g, ' $1');

  return result.charAt(0).toUpperCase() + result.slice(1);
}

export function dateFormat(date: string): string | null {
  return date ? date.split('-').reverse().join('/') : null;
}

export function numberFormat(num: any): string | null {
  return Number(num).toLocaleString('en-IN');
}

export function zohoCustomerStatementDownloadFromResponse(response: Blob, customerName: string) {
  const blob = new Blob([response], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.download = 'Customer Statement - ' + customerName + '.pdf';
  a.href = url;
  a.click();
}
